//* /[accountId]/[adUnitCode]
const googleAdIds = {
	horizontal_banner: "/22866222029/horizontal-v3"
};

export default googleAdIds;
